export default "// ensure Vue CLI is >= 3.0\n$ vue --version\n\n// Then start the UI\n$ vue ui\n";